import { Component, Input, Output, EventEmitter } from "@angular/core";

export interface NotificationChannels {
  whatsapp: any;
  sms: boolean;
  // whatsapp: boolean;
  email: boolean;
}

@Component({
  standalone: false,
  selector: "app-notification-type-card",
  templateUrl: "./notification-type-card.component.html", // ✔ point to its own template
  styleUrls: ["./notification-type-card.component.css"], // ✔ its own CSS
})
export class NotificationTypeCardComponent {
  @Input() title: string = "Notification";
  @Input() description: string = "";
  @Input() channels: NotificationChannels = {
    sms: false,
    // whatsapp: false,
    email: false,
    whatsapp: undefined
  };

  @Input() enabled = false;

  @Output() enabledChange = new EventEmitter<boolean>();
  @Output() channelsChange = new EventEmitter<NotificationChannels>();

  toggleEnabled() {
    const nextEnabled = !this.enabled;
    this.enabledChange.emit(nextEnabled);

    this.channelsChange.emit(
      nextEnabled ? { sms: true, email: true, whatsapp : undefined } : { sms: false, email: false, whatsapp : undefined }
    );
  }

  toggleChannel(channel: keyof NotificationChannels) {
    // Toggle the channel
    const updated = {
      ...this.channels,
      [channel]: !this.channels[channel],
    };

    // If any channel is true, main checkbox should be enabled
    const anyChecked = Object.values(updated).some((v) => v === true);

    // Emit main checkbox state
    this.enabledChange.emit(anyChecked);

    // Emit updated channels
    this.channelsChange.emit(updated);
  }
}
